import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DetailDocumentIntegration {
  exitTravelDocument$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
}
